/*!
=========================================================
* 依頼（駐車場）登録
=========================================================
*/
import React from "react";

import {
  Button,
  Card,  CardHeader,  CardBody,  CardTitle, 
  Table,  Row,  Col,
} from "reactstrap";

import Request from '../../common/Request';
import SystemInfo from '../ViewParts/SystemInfo';
import CustomTd from '../ViewParts/CustomTd';
import WithRole from '../FormParts/ButtonWithRole';

var domain = "";  

class List extends React.Component {
  constructor(props){
    super(props);
    
    const box_status = new URL(window.location.href).searchParams.get("box_status")
    // 遷移先に遷移元を示すパラメータを渡す
    const box_status_param = `?box_status=${box_status}`
    // 遷移元に戻るための設定
    const transition_url = box_status === "0" ? "/construction/list" : "/construction/new_customer";

    this.state ={
      detail_search: "off",
      error_modal: false,
      view: false,
      valid: true,
      request:{},
      project:{},
      customer1:{},
      customer2:{},
      data:{
        values:{},
        errors:{},
        requiredData:{}
      },
      landmark_branch:{},
      box_status : box_status,
      box_status_param : box_status_param,
      transition_url : transition_url
    };
  } 

  // 初期ロード用
  componentDidMount(){
    if(this.props.match.params.order_id !== undefined){
      const url = domain + '/api/request/'+this.props.match.params.order_id;
      Request.get(url,{}, res => {

        const {web_survey_account} = res.Data

        web_survey_account && Request.get(`/api/landmark/user?user_id=${web_survey_account}`,{},(userResp)=>{
          res.Data["web_survey_account_name"] = userResp.Data[0] ? userResp.Data[0].name : ""
        })

        this.setState({ 
          data: {
            ...this.state.data,
            values:res.Data, 
          },
        });
        var url = domain + '/api/landmark/lastupdate/' + res.Data.lastupdate_user_id;
        var params = {};
        Request.get(url, params, res => {
          let tmp = this.state.data.values;
          tmp.lastupdate_user = res.Data;
          // console.log(res.Data)
          this.setState({data:{values:tmp}});
        });      
        
        if (res.Data.user_branch_natural_id){
          Request.get('/api/landmark/user_branch', {
            user_branch_natural_id:res.Data.user_branch_natural_id
          }, res=>{
            this.setState({
              landmark_branch: res.Data[0]
            })
          })
        }

        const customerUserApiEndPoint = '/api/customer/user'
        // 下請けじゃない方は依頼テーブルから
        if (res.Data.customer_user_natural_id){
          Request.get(customerUserApiEndPoint, {
            customer_user_natural_id:res.Data.customer_user_natural_id
          }, res=>{
            this.setState({
              customer1: res.Data[0]
            })
          })
        }


        const constructionUrl = domain + '/api/construction/'+res.Data.project_ulid+"?project_only=true";
        Request.get(constructionUrl,{
          project_ulid: this.props.match.params.project_id
        }, res => {
          this.setState({
            request:res.Data.request[0],
          })
          
          // 下請けは工事テーブルから
          if (res.Data.subcontract_customer_user_natural_id){
            Request.get(customerUserApiEndPoint, {
              customer_user_natural_id:res.Data.subcontract_customer_user_natural_id
            }, res=>{
              this.setState({
                customer2: res.Data[0]
              })
            })
          }
        });
      });
    }
  }

  returnNumber(val){
    return isNaN(Number(val))?0:Number(val)
  }

  calculate_SUM_request_parking_qty(values){
    return this.returnNumber(values.car_qty) + this.returnNumber(values.light_truck_qty)+ this.returnNumber(values.truck_qty)+ this.returnNumber(values.other_car_qty);
  }
  
  render() {
    const {
      customer1, 
      customer2
    } = this.state
    const {
      values
    } = this.state.data
    const ButtonWithRole = WithRole(Button, this.props.buttons, this.state.request)
    console.log('state', this.state)
    return (
      <>
    <div className="content">
      <Row>
      <Col md="12">
      <Card>
      <CardHeader className="clearfix">
        <CardTitle tag="h3" className="float-left">依頼（駐車場）詳細</CardTitle>
        <ButtonWithRole
          button_id="BTN_A2_02_01190"
          className="float-right"
          onClick={() => {
            this.props.history.push(`/construction/parking/update/${values.ulid}${this.state.box_status_param}`)
          }}
        >
          編集
        </ButtonWithRole>
      </CardHeader>
      
      <Col md="11" className="detail">
        <CardBody>
          <SystemInfo
            id_title='案件ID'
            id_value={values.request_natural_id}
            update_timestamp={values.update_timestamp}
            update_user={values.lastupdate_user && values.lastupdate_user.name}
            update_user_picture={values.lastupdate_user && values.lastupdate_user.picture}
          />
            <Table>
              <tbody>
                <tr>      
                  <CustomTd 
                    label="会社名" 
                    name="CUSTOMER__customer_name" 
                    copy={false}
                    data={customer1} 
                  />
                </tr>
                <tr>
                  <CustomTd 
                    label="支店名" 
                    name="CUSTOMER_BRANCH__customer_branch_name" 
                    copy={false} 
                    data={customer1} 
                  />
                </tr>
                <tr>
                  <CustomTd 
                    label="電話番号" 
                    name="CUSTOMER_BRANCH__customer_branch_tel" 
                    copy={false} 
                    data={customer1}
                  />                      
                </tr>
                <tr>
                  <CustomTd 
                    label="FAX番号" 
                    name="CUSTOMER_BRANCH__customer_branch_fax" 
                    copy={false} 
                    data={customer1} 
                  />
                </tr>
                <tr>
                  <CustomTd 
                    label="顧客担当者" 
                    name="CUSTOMER_USER__customer_user_name" 
                    copy={false} 
                    data={customer1} 
                  />
                </tr>
                <tr>
                  <CustomTd 
                    label="携帯電話番号" 
                    name="CUSTOMER_USER__customer_user_tel" 
                    copy={false} 
                    data={customer1} 
                  />
                </tr>
                <tr>
                  <CustomTd 
                    label="固定電話番号" 
                    name="CUSTOMER_USER__customer_user_tel2" 
                    copy={false} 
                    data={customer1} 
                  />
                </tr>
                <tr>
                  <CustomTd 
                    label="メールアドレス" 
                    name="CUSTOMER_USER__customer_user_email" 
                    copy={false} 
                    data={customer1} 
                  />
                </tr>
                <tr>
                  <CustomTd 
                    label="会社名（下請）" 
                    name="CUSTOMER__customer_name" 
                    copy={false}
                    data={customer2} 
                  />
                </tr>
                <tr>
                  <CustomTd 
                    label="支店名（下請）" 
                    name="CUSTOMER_BRANCH__customer_branch_name" 
                    copy={false} 
                    data={customer2} 
                  />
                </tr>
                <tr>
                  <CustomTd 
                    label="電話番号（下請）" 
                    name="CUSTOMER_BRANCH__customer_branch_tel" 
                    copy={false} 
                    data={customer2}
                  />                      
                </tr>
                <tr>
                  <CustomTd 
                    label="FAX番号（下請）" 
                    name="CUSTOMER_BRANCH__customer_branch_fax" 
                    copy={false} 
                    data={customer2} 
                  />
                </tr>
                <tr>
                  <CustomTd 
                    label="顧客担当者（下請）" 
                    name="CUSTOMER_USER__customer_user_name" 
                    copy={false} 
                    data={customer2} 
                  />
                </tr>
                <tr>
                  <CustomTd 
                    label="携帯電話番号（下請）" 
                    name="CUSTOMER_USER__customer_user_tel" 
                    copy={false} 
                    data={customer2} 
                  />
                </tr>
                <tr>
                  <CustomTd 
                    label="固定電話番号（下請）" 
                    name="CUSTOMER_USER__customer_user_tel2" 
                    copy={false} 
                    data={customer2} 
                  />
                </tr>
                <tr>
                  <CustomTd 
                    label="メールアドレス（下請）" 
                    name="CUSTOMER_USER__customer_user_email" 
                    copy={false} 
                    data={customer2} 
                  />
              </tr>
              </tbody>
            </Table>
            <Table>                
              <tbody>
                <tr>
                  <CustomTd label='現場担当者'
                    name='PROJECT__site_customer_user_name'
                    copy={false}
                    data={values} />
                </tr>
                <tr>
                  <CustomTd label='現場担当者電話番号'
                    name='PROJECT__site_customer_user_tel'
                    copy={false}
                    data={values} />
                </tr>
                <tr>
                  <CustomTd label='工事番号'
                    name='PROJECT__construction_number'
                    copy={false}
                    data={values} />
                </tr>
                <tr>
                  <CustomTd label='現場名'
                    name='PROJECT__site_name'
                    copy={false}
                    data={values} />
                </tr>
                <tr>
                  <CustomTd label='現場名（カナ）'
                    name='PROJECT__site_name_kana'
                    copy={false}
                    data={values} />
                </tr>
                <tr>
                  <CustomTd label='工事開始日'
                    name='PROJECT__project_start_date'
                    copy={false}
                    data={values} />
                </tr>
                <tr>
                  <CustomTd label='工事終了日'
                    name='PROJECT__project_finish_date'
                    copy={false}
                    data={values} />
                </tr>
                <tr>
                  <CustomTd label='都道府県'
                    name='PROJECT__site_prefecture'
                    copy={false}
                    data={values} />
                </tr>
                <tr>
                  <CustomTd label='市区町村'
                    name='PROJECT__site_city'
                    copy={false}
                    data={values} />
                </tr>
                <tr>
                  <CustomTd label='番地（町名以降）'
                    name='PROJECT__site_address'
                    copy={false}
                    data={values} />
                </tr>
                <tr>
                  <CustomTd 
                    label="送付先"
                    name="PROJECT__send_destination_type" 
                    copy={false} 
                    data={values}
                  />
                </tr>
                <tr>
                  <CustomTd label='担当支店'
                    name='REQUEST__user_branch_name'
                    copy={false}
                    data={this.state.landmark_branch} />
                </tr>
                <tr>
                  <CustomTd label='調査担当者'
                    name='NODB__web_survey_account_name'
                    copy={false}
                    data={values} />
                </tr>
              </tbody>
            </Table>
          </CardBody>
          <CardBody>
            <Table className="tablesorter">
              <tbody>
                <tr>
                  {/* <th rowSpan='3' className='text-left'>依頼情報</th> */}
                  <CustomTd label='依頼種別'
                    name='REQUEST__request_type'
                    copy={false}
                    data={values} />
                </tr>
                <tr>
                  <CustomTd label='受付日'
                    name='REQUEST__request_date'
                    copy={false}
                    data={values} />
                </tr>
                <tr>
                  <CustomTd label='見積提出期限'
                    name='REQUEST__estimate_deadline'
                    copy={false}
                    data={values} />
                </tr>
                <tr>
                  {/* <th rowSpan='2' className='text-left'>利用期間</th> */}
                  <CustomTd label='利用開始日'
                    name='REQUEST__want_start_date'
                    copy={false}
                    data={values} />
                </tr>
                <tr>
                  <CustomTd label='利用終了日'
                    name='REQUEST__want_end_date'
                    copy={false}
                    data={values} />
                </tr>
                <tr>
                  <CustomTd label='再調査フラグ'
                    name='REQUEST__resurvey_flag'
                    copy={false}
                    data={values} />
                </tr>
                <tr>
                  {/* <th rowSpan='6' className='text-left'>利用台数</th> */}
                  <CustomTd label='ワゴン車'
                    name='REQUEST__car_qty'
                    copy={false}
                    data={values} />
                </tr>
                <tr>
                  <CustomTd label='軽トラック'
                    name='REQUEST__light_truck_qty'
                    copy={false}
                    data={values} />
                </tr>
                <tr>
                  <CustomTd label='2tトラック'
                    name='REQUEST__truck_qty'
                    copy={false}
                    data={values} />
                </tr>
                <tr>
                  <CustomTd label='その他（計）'
                    name='REQUEST__other_car_qty'
                    copy={false}
                    data={values} />
                </tr>
                <tr>
                  <CustomTd label='その他詳細'
                    name='REQUEST__other_car_detail'
                    copy={false}
                    data={values} />
                </tr>
                <tr>
                  {/* <th rowSpan='5' className='text-left'>希望詳細</th> */}
                  <CustomTd label='顧客からの要望'
                    name='REQUEST__customer_other_request'
                    copy={false}
                    data={values} />
                </tr>
                <tr>
                  <CustomTd label='案内方法'
                    name='REQUEST__want_guide_type'
                    copy={false}
                    data={values} />
                </tr>
                <tr>
                  <CustomTd label='案内方法（下請）'
                    name='REQUEST__want_guide_type_subcontract'
                    copy={false}
                    data={values} />
                </tr>
                <tr>
                  <CustomTd label='CCメールアドレス'
                    name='REQUEST__cc_email'
                    copy={false}
                    data={values} />
                </tr>
                <tr>
                  <CustomTd label='今回利用台数'
                    name='___SUM_request_parking_qty'
                    copy={false}
                    value={this.calculate_SUM_request_parking_qty(values)+"台"} />
                </tr>
                {this.state.data.values.auto_order_display_flag == 1 &&
                <tr>
                  <CustomTd label='自動発注機能'
                    name='REQUEST__auto_order_function_flag'
                    copy={false}
                    data={values} />
                </tr>}
              </tbody>
            </Table>
          </CardBody>
        </Col>
        <Row md='12' className="detail">
          <Col md='6' className="text-center">
            <Button color="secondary" onClick={() => { this.props.history.push(this.state.transition_url) }}>一覧に戻る</Button>
          </Col>
        </Row>
        </Card>
        </Col>
        </Row>
      </div> 
     </>
    );

  }
}

export default List;
